<main class="d-flex justify-content-center align-items-center">
    <div class="col-md-6 text-center">
        <img class="w-50" [src]="imgConfiguration['SURVEY_APP.SAND_CLOCK_GIF']" alt="Loader">
        <p class="assessment-text-grey-ten assessment-text-bold-26">{{'HANG.ON'|translate}}</p>
        <p class="assessment-text-grey-seven assessment-text-medium-20">{{'SYSTEM.UPDATE.MESSAGE'|translate}}</p>
    </div>
</main>